module.exports = global.config = {
    endpoint : "https://backend.kaci.opsinno.com"
    // endpoint : "http://34.117.119.72:80"
    // other global config variables you wish
};